import { Box } from "@mui/material";
import { ParagraphText } from "../../../../../Libraries";
import imagePlaceholder from "../../../../../assets/images/imagePlaceholder.png";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import styles from "../../TransactionListing/TransactionListing.module.css";

const VendorRow = ({ item, onViewTransactions }) => {
  const { company_name, logo_link, phone } = item || {};

  return (
    <Box
      id={`voucher_transaction_vendor_row_${company_name}`}
      className="invoiceListTableBody accountTableHeaderMain pointer"
      onClick={() => {
        triggerLogEvent(analytics, "w_voucher_txn_vendor_detail");
        onViewTransactions?.(item);
      }}
    >
      <Box className={`invListTableHeaderCol fourColumn textLeft ${styles.contactCell}`}>
        <img
          src={logo_link || imagePlaceholder}
          alt={company_name}
          className={styles.companyLogo}
          onError={(e) => { e.target.src = imagePlaceholder; }}
        />
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine newFontColor">
          {company_name || "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {phone || "-"}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default VendorRow;
